import { render, staticRenderFns } from "./ListDivisi.vue?vue&type=template&id=3650c3fc&"
import script from "./ListDivisi.vue?vue&type=script&lang=js&"
export * from "./ListDivisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports